<template>
	<a :href="linkURL" target="_blank" rel="noopener">{{ text }}</a>
</template>

<script>
export default {
	props: {
		linkURL: {
			type: String,
		},
		text: {
			type: String,
			require: true,
		}
	}
}
</script>

<style>

</style>